import Session from './session'

export default class CommonAPI {

  static get PREFIX () {
    return Session.HOST + '/api/common/'
  }

  /**
  * サインアップ
  */
  static signUp (data) {
    const s = new Session()
    return s.ins.post(CommonAPI.PREFIX + 'sign-up', data)
      .then(res => {
        // success
        return res
      })
      .catch(error => {
        // error
        return Promise.reject(error || 'ERROR')
      })
  }

  /**
   * ログイン
   */
  static login (data) {
    const s = new Session()
    return s.ins.post(CommonAPI.PREFIX + 'login', data)
      .then(res => {
        // success
        return res
      })
      .catch(error => {
        // error
        return Promise.reject(error || 'ERROR')
      })
  }

  /**
  * ログインスタッフ取得
  */
  static getLoginUser () {
    const s = new Session()
    return s.ins.post(CommonAPI.PREFIX + 'login-user')
      .then(res => {
        // success
        return res
      })
      .catch(error => {
        // error
        return Promise.reject(error || 'ERROR')
      })
  }

  /**
   * ログアウト
   */
  static logout () {
    const s = new Session()
    return s.ins.post(CommonAPI.PREFIX + 'logout')
      .then(res => {
        return res
      })
      .catch(error => {
        return Promise.reject(error || 'ERROR')
      })
  }

  /**
   * パスワードリセット
   */
  static resetPassword (mail) {
    const s = new Session()
    return s.ins.post(CommonAPI.PREFIX + 'reset-password', {mail: mail})
      .then(res => {
        return res
      })
      .catch(error => {
        return Promise.reject(error || 'ERROR')
      })
  }

  /**
   * 祝日日付一覧取得
   */
  static getHolidayDateList () {
    const s = new Session()
    return s.ins.get(CommonAPI.PREFIX + 'holiday/list/date')
      .then(res => {
        return res
      })
      .catch(error => {
        return Promise.reject(error || 'ERROR')
      })
  }

  /**
   * 郵便番号検索
   */
  static searchAddress (postalCode) {
    const s = new Session()
    return s.ins.get(CommonAPI.PREFIX + 'searchAddress?postalCode=' + postalCode)
      .then(res => {
        return res
      })
      .catch(error => {
        return Promise.reject(error || 'ERROR')
      })
  }

}



// WEBPACK FOOTER //
// ./src/assets/js/api/common-api.js